import React, { useEffect } from 'react';
import { AuthState } from '../types/app';
import { authService } from '../services/authService';

interface AuthCallbackProps {
  onAuthComplete: (authState: AuthState) => void;
}

export const AuthCallback: React.FC<AuthCallbackProps> = ({ onAuthComplete }) => {
  useEffect(() => {
    const handleCallback = () => {
      const hash = window.location.hash;
      if (hash) {
        const authState = authService.handleAuthCallback(hash);
        if (authState) {
          onAuthComplete(authState);
          // Clear the hash and redirect to home
          window.history.replaceState({}, document.title, '/');
        } else {
          // Handle error case
          console.error('Failed to parse auth callback');
          window.location.href = '/';
        }
      } else {
        // No hash found, redirect to home
        window.location.href = '/';
      }
    };

    handleCallback();
  }, [onAuthComplete]);

  return (
    <div className="auth-callback">
      <h2>Completing authentication...</h2>
      <p>Please wait while we connect to your YNAB account.</p>
    </div>
  );
};
